/*
 *
 * ConsentsPopup
 *
 * @version 1.0.0
 * @author Lucio Chiummo
 * @since 03-Oct-2025
 */

import React from 'react'
import PropTypes from 'prop-types'
import formattedMessage from './languageModule'
import Toggle from 'Hoc/ToggleComponent'
import './ConsentsPopup.scss'
import MerchantModal from '@nexidigital/merchantmodal'
import MerchantGenericCard from '@nexidigital/merchantgenericcard'
import PortalRadioBox from '@nexidigital/portalradiobox'
import { useFormik } from 'formik'
import * as Yup from 'yup'

const ConsentsPopup = (props) => {
  // useEffect(() => {
  //   props.actions.doShowPopup(flowPopupMapType.AML_MODAL);
  // }, []);
  const C3 = 'consent3Value'
  const C4 = 'consent4Value'
  const C5 = 'consent5Value'
  const options = [
    {
      label: formattedMessage.radioYes,
      value: true
    },
    {
      label: formattedMessage.radioNo,
      value: false
    }
  ]
  const validationSchema = Yup.object().shape({
    [C3]: Yup.boolean().required(formattedMessage.requiredError).oneOf([true, false], formattedMessage.requiredError),
    [C4]: Yup.boolean().required(formattedMessage.requiredError).oneOf([true, false], formattedMessage.requiredError),
    [C5]: Yup.boolean().required(formattedMessage.requiredError).oneOf([true, false], formattedMessage.requiredError)
  })
  const initialValues = {
    [C3]: '',
    [C4]: '',
    [C5]: ''
  }
  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values) => {
      const payload = {
        consent3Value: values[C3] === 'true',
        consent4Value: values[C4] === 'true',
        consent5Value: values[C5] === 'true'
      }
      props.actions.updateConsents(payload)
      props.actions.doHideTtl()
      props.actions.doRetrieveTTL()
    }
  })

  const setRadioValue = (key, value) => {
    formik.setFieldValue(key, value)
    formik.setFieldError(key, '')
    formik.setFieldTouched(key, true)
  }

  const onClose = () => {
    props.actions.doHideTtl()
    props.actions.doRetrieveTTL()
  }

  return (
    <Toggle>
      <MerchantModal
        ariaModalDescription=''
        ariaModalTitle=''
        title={formattedMessage.title}
        onClose={() => onClose()}
        topBarTitle=' '
        /* eslint-disable-next-line react/jsx-handler-names */
        primaryAction={formik.handleSubmit}
        primaryButtonLabel={formattedMessage.confirm}
      >
        <MerchantGenericCard empty>
          <div className='consentsPopupCard'>
            <div className='containerHeaderTitle'>
              <b className='consentsTitle'>{formattedMessage.t1Title}</b>
              <div className='consentsDesc'>{formattedMessage.t1Description}</div>
            </div>
            <div className='consentsPopupOptions'>
              <div className='consentOption'>
                <b className='consentsOptionTitle'>{formattedMessage.c1Title}</b>
                <div className='consentsOptionDescription'>{formattedMessage.c1Description}</div>
                <PortalRadioBox
                  noPreselection
                  defaultValue={formik.values[C3]}
                  onChange={(e) => setRadioValue(C3, e)}
                  options={options.map((option) => ({
                    ...option,
                    error: formik.touched[C3] && formik.errors[C3]
                  }))}
                  row
                  centered
                  groupErrorMessage={formik.errors[C3]}
                />
              </div>
              <div className='consentOption'>
                <b className='consentsOptionTitle'>{formattedMessage.c2Title}</b>
                <div className='consentsOptionDescription'>{formattedMessage.c2Description}</div>
                <PortalRadioBox
                  noPreselection
                  defaultValue={formik.values[C4]}
                  onChange={(e) => setRadioValue(C4, e)}
                  options={options.map((option) => ({
                    ...option,
                    error: formik.touched[C4] && formik.errors[C4]
                  }))}
                  row
                  centered
                  groupErrorMessage={formik.errors[C4]}
                />
              </div>
              <div className='consentOption'>
                <b className='consentsOptionTitle'>{formattedMessage.c3Title}</b>
                <div className='consentsOptionDescription'>{formattedMessage.c3Description}</div>
                <PortalRadioBox
                  noPreselection
                  defaultValue={formik.values[C5]}
                  onChange={(e) => setRadioValue(C5, e)}
                  options={options.map((option) => ({
                    ...option,
                    error: formik.touched[C5] && formik.errors[C5]
                  }))}
                  row
                  centered
                  groupErrorMessage={formik.errors[C5]}
                />
              </div>
            </div>
          </div>
        </MerchantGenericCard>
      </MerchantModal>
    </Toggle>
  )
}

ConsentsPopup.propTypes = {
  actions: PropTypes.object
}

ConsentsPopup.defaultProps = {
  actions: {}
}

export default ConsentsPopup
